import { useRoute } from "vue-router";
import { useStore } from "vuex";
export const useCurrentCustomerName = () => {
    const { params } = useRoute();
    return params.customer_name;
};
export const useCurrentSiteId = () => {
    const { params } = useRoute();
    return params.site_id;
};
export const useHasPermissionForUser = (user, groups, customerName, siteId) => {
    const requiredGroups = Array.isArray(groups)
        ? groups
        : [groups];
    if (requiredGroups.some((requiredGroup) => Array.isArray(requiredGroup)
        ? requiredGroup.every((userGroup) => user.groups.includes(userGroup))
        : user.groups.includes(requiredGroup))) {
        return true;
    }
    customerName = customerName || useCurrentCustomerName();
    siteId = siteId || useCurrentSiteId();
    if (customerName && siteId) {
        const project = user.projects.find((project) => project.customer_name === customerName && project.site_id === siteId);
        if (requiredGroups.some((requiredGroup) => Array.isArray(requiredGroup)
            ? requiredGroup.every((userProjectGroup) => project === null || project === void 0 ? void 0 : project.groups.includes(userProjectGroup))
            : project === null || project === void 0 ? void 0 : project.groups.includes(requiredGroup))) {
            return true;
        }
    }
    return false;
};
export const useHasPermission = (groups, customerName, siteId) => {
    const store = useStore();
    const user = store.state.user;
    if (!user) {
        return false;
    }
    return useHasPermissionForUser(user, groups, customerName, siteId);
};
//# sourceMappingURL=project.js.map